import React from "react";
import Chat from "./Chat";
import { Paper } from "@mui/material";

const ChatPage: React.FC = () => {
  return (
    <Paper variant="basePaper" sx={{}}>
      <Chat />
    </Paper>
  );
};

export default ChatPage;
